// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { productCardProps } from "@store/Themes/common/props/productCard";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Components/Toolkit/AddToCartOptionsAndButton";
import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import { TypographyPresentationProps } from "@insite/mobius/Typography";

const descriptionTypographyProps: TypographyPresentationProps = {
    css: css`
        white-space: initial;
    `,
};
/* Starter Custom Code - End */

interface OwnProps {
    product: ProductModel;
    widgetId: string;
    showBrand: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAvailability: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    extendedStyles?: PurchasedProductCardStyles;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productSettings: getSettingsCollection(state).productSettings,
    productInfo: getProductInfoFromList(state, ownProps.widgetId, ownProps.product.id),
});

const mapDispatchToProps = {
    updateProductInfo,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PurchasedProductCardStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoContainer?: GridContainerProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    partNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    availabilityStyles?: ProductAvailabilityStyles;
    priceGridItem?: GridItemProps;
    priceStyles?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    actionsGridItem?: GridItemProps;
    actionsContainer?: GridContainerProps;
    quantityGridItem?: GridItemProps;
    quantityOrdered?: TextFieldPresentationProps;
    addToGridItem?: GridItemProps;
    addToCartButton?: ButtonPresentationProps;
    addToListWrapper?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
    // Starter Custom Code
    priceAndAvailabilityGridItem?: GridItemProps;
    priceAndAvailabilityInnerContainer?: GridContainerProps;
    uomAndQuantityGridItem?: GridItemProps;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
}

export const purchasedProductCardStyles: PurchasedProductCardStyles = {
    container: productLineProps.contentContainer,
    leftColumnGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    addToListLink: mergeProps<PurchasedProductCardStyles["addToListLink"]>(productCardProps.addToListLink, {
        link: {
            css: css`
                white-space: initial;
            `,
        },
    }),
    rightColumnGridItem: productLineProps.contentGridItem,
    rightColumnGridContainer: productLineProps.contentContainer,
    infoGridItem: {
        width: [12, 12, 12, 5, 5],
        printWidth: 5,
    },
    infoContainer: productLineProps.infoContainer,
    descriptionGridItem: productLineProps.descriptionGridItem,
    brandStyles: productLineProps.brand,
    descriptionStyles: mergeProps(productLineProps.description, {
        productDetailLink: {
            typographyProps: descriptionTypographyProps,
        },
        productDetailDescription: descriptionTypographyProps,
    }),
    partNumbersGridItem: productLineProps.partNumbersGridItem,
    partNumbersStyles: productLineProps.partNumbers,
    availabilityGridItem: productLineProps.availabilityGridItem,
    availabilityStyles: productLineProps.availability,
    priceAndAvailabilityGridItem: {
        width: [12, 12, 12, 7, 7],
        printWidth: 7,
    },
    priceAndAvailabilityInnerContainer: productLineProps.pricingContainer,
    priceGridItem: mergeProps<PurchasedProductCardStyles["priceGridItem"]>(productLineProps.priceGridItem, {
        width: [12, 5, 5, 6, 6],
        printWidth: 5,
    }),
    priceStyles: mergeProps(productLineProps.price, {
        wrapper: {
            css: css`
                white-space: initial;
            `,
        },
    }),
    quantityBreakPricing: productCardProps.quantityBreakPricing,
    uomAndQuantityGridItem: { width: [12, 7, 7, 6, 6], printWidth: 7 },
    addToCartOptionsAndButton: mergeProps<PurchasedProductCardStyles["addToCartOptionsAndButton"]>(
        productCardProps.addToCartOptionsAndButton,
        {
            flexWrapper: {
                extendedStyles: {
                    wrapper: {
                        css: css`
                            width: 100%;
                        `,
                    },
                },
            },
            addToCartButton: {
                extendedStyles: {
                    button: {
                        css: css`
                            flex: 1 0 50%;
                        `,
                    },
                },
            },
            quantityOrdered: {
                extendedStyles: productLineProps.textField,
            },
            unitOfMeasure: {
                extendedStyles: productLineProps.textField,
            },
        },
    ),
};

const PurchasedProductCard: React.FC<Props> = ({
    product,
    productInfo,
    showBrand,
    showPartNumbers,
    showPrice,
    showAvailability,
    showAddToCart,
    showAddToList,
    productSettings,
    extendedStyles,
    updateProductInfo,
    widgetId,
}) => {
    const [styles] = React.useState(() => mergeToNew(purchasedProductCardStyles, extendedStyles));

    if (!productInfo || !product) {
        return null;
    }

    const productContext: ProductContextModel = {
        product,
        productInfo,
        onUnitOfMeasureChanged: unitOfMeasure => {
            updateProductInfo({ id: widgetId, productId: product.id, unitOfMeasure });
        },
        onQtyOrderedChanged: qtyOrdered => {
            updateProductInfo({ id: widgetId, productId: product.id, qtyOrdered });
        },
    };

    return (
        <ProductContext.Provider value={productContext} data-test-selector="widget_PurchasedProducts">
            <DataTableRow /* Starter Custom Code */>
                <DataTableCell /* Starter Custom Code */>
                    <GridContainer {...styles.container} data-test-selector={`purchasedProductCard_${product.id}`}>
                        <GridItem {...styles.leftColumnGridItem}>
                            <ProductImage extendedStyles={styles.productImage} product={productContext} />
                            {/* Starter Custom Code - Start */}
                            {showAddToList && (
                                <ProductAddToListLink
                                    data-test-selector={`actionsAddToList${product.id}`}
                                    extendedStyles={styles.addToListLink}
                                />
                            )}
                            {/* Starter Custom Code - End */}
                        </GridItem>
                        <GridItem {...styles.rightColumnGridItem}>
                            <GridContainer {...styles.rightColumnGridContainer}>
                                <GridItem {...styles.infoGridItem}>
                                    <GridContainer {...styles.infoContainer}>
                                        <GridItem {...styles.descriptionGridItem} /* Starter Custom Code */>
                                            {product.brand && showBrand && (
                                                <ProductBrand
                                                    brand={product.brand}
                                                    extendedStyles={styles.brandStyles}
                                                />
                                            )}
                                            <ProductDescription
                                                product={productContext}
                                                extendedStyles={styles.descriptionStyles}
                                            />
                                        </GridItem>
                                        {showPartNumbers && (
                                            <GridItem {...styles.partNumbersGridItem}>
                                                <ProductPartNumbers
                                                    productNumber={product.productNumber}
                                                    customerProductNumber={product.customerProductNumber}
                                                    manufacturerItem={product.manufacturerItem}
                                                    extendedStyles={styles.partNumbersStyles}
                                                />
                                            </GridItem>
                                        )}
                                        {productSettings.showInventoryAvailability && showAvailability && (
                                            <GridItem {...styles.availabilityGridItem}>
                                                <ProductContextAvailability
                                                    extendedStyles={styles.availabilityStyles}
                                                />
                                            </GridItem>
                                        )}
                                    </GridContainer>
                                </GridItem>
                                <GridItem {...styles.priceAndAvailabilityGridItem} /* Starter Custom Code */>
                                    <GridContainer
                                        {...styles.priceAndAvailabilityInnerContainer} /* Starter Custom Code */
                                    >
                                        {showPrice && (
                                            <>
                                                <GridItem {...styles.priceGridItem} /* Starter Custom Code */>
                                                    <ProductPrice
                                                        product={productContext}
                                                        showLabel={false}
                                                        showSavings={true}
                                                        showSavingsAmount={productSettings.showSavingsAmount}
                                                        showSavingsPercent={productSettings.showSavingsPercent}
                                                        extendedStyles={styles.priceStyles}
                                                    />
                                                    <ProductQuantityBreakPricing
                                                        extendedStyles={
                                                            styles.quantityBreakPricing
                                                        } /* Starter Custom Code */
                                                    />
                                                </GridItem>
                                                {showAddToCart && (
                                                    /* Starter Custom Code - Start */
                                                    <GridItem {...styles.uomAndQuantityGridItem}>
                                                        <AddToCartOptionsAndButton
                                                            extendedStyles={{
                                                                ...styles.addToCartOptionsAndButton,
                                                                unitOfMeasure: {
                                                                    ...styles.addToCartOptionsAndButton?.unitOfMeasure,
                                                                    uid: `uom-${productContext.product.id}`,
                                                                },
                                                                quantityOrdered: {
                                                                    ...styles.addToCartOptionsAndButton
                                                                        ?.quantityOrdered,
                                                                    id: `qty-ordered-${productContext.product.id}`,
                                                                },
                                                                addToCartButton: {
                                                                    ...styles.addToCartOptionsAndButton
                                                                        ?.addToCartButton,
                                                                    "data-test-selector": `actionsAddToCart${product.id}`,
                                                                },
                                                            }}
                                                        />
                                                    </GridItem>
                                                    /* Starter Custom Code - End */
                                                )}
                                            </>
                                        )}
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </DataTableCell>
            </DataTableRow>
        </ProductContext.Provider>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchasedProductCard);
